import { jsx as r } from "@emotion/react/jsx-runtime";
import { ShortcutContainer as m, ShortcutItem as p } from "./Shortcut.styled.js";
import { Text as d } from "../../Text/index.js";
import { useDatePickerContext as h } from "../DatePickerContext.js";
import { getDateByCriteria as v } from "../helpers.js";
const x = ({
  shortcutItems: n
}) => {
  const {
    activeShortcut: e,
    setActiveShortcut: c,
    onChange: l,
    setDisplayCalendar: i,
    setActiveInput: u
  } = h(), s = (t) => {
    t.preventDefault(), c(t.currentTarget.value);
    const {
      start: a,
      end: o
    } = v(t.currentTarget.value);
    a && o && (l([a, o]), i(!1), u(null));
  };
  return /* @__PURE__ */ r(m, { children: n.map((t) => /* @__PURE__ */ r(p, { onClick: s, value: t.name, isActive: e === t.name, children: /* @__PURE__ */ r(d, { variant: "bodyMBold", as: "div", color: e === t.name ? "primary" : "secondary", children: t.label }) }, `${t.label}`)) });
};
export {
  x as Shortcut
};
